import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SingleSelectDropdownComponent } from '../../single-select-dropdown.component';
import { OffcanvasSheetComponent } from '../../../shared/offcanvas-sheet/offcanvas-sheet.component';

export type BusinessOffcanvasMode = 'variable' | 'fixed' | 'salary' | 'employee';

@Component({
  selector: 'app-business-item-offcanvas',
  standalone: true,
  imports: [CommonModule, FormsModule, SingleSelectDropdownComponent, OffcanvasSheetComponent],
  templateUrl: './business-item-offcanvas.component.html',
  styleUrls: ['../../../shared/offcanvas-sheet/offcanvas-sheet.shared.css'],
})
export class BusinessItemOffcanvasComponent implements OnChanges {
  @Input() visible = false;
  @Input() mode: BusinessOffcanvasMode = 'variable';
  @Input() item: any = null;
  @Input() employees: any[] = [];
  @Input() roles: any[] = [];
  @Input() periodTypes: any[] = [];
  @Input() variableOverheads: { value: string; label: string }[] = [];
  @Input() fixedOverheads: { value: string; label: string }[] = [];
  @Input() unitsOfMeasure: any[] = [];

  compareById = (a: any, b: any): boolean => Number(a) === Number(b);

  get variableOverheadOptions(): { value: string; label: string }[] {
    return [...this.variableOverheads];
  }

  get fixedOverheadOptions(): { value: string; label: string }[] {
    return [...this.fixedOverheads, { value: 'custom', label: 'Custom Fixed Cost' }];
  }

  get employeeOptions(): { value: string; label: string }[] {
    return this.employees.map(e => ({ value: String(e.employeeID), label: `${e.firstName} ${e.lastName}` }));
  }

  get roleOptions(): { value: string; label: string }[] {
    return this.roles.map(r => ({ value: String(r.roleID), label: r.roleName }));
  }

  get periodTypeOptions(): { value: string; label: string }[] {
    return this.periodTypes.map(pt => ({ value: String(pt.periodTypeID), label: pt.description }));
  }

  get uomOptions(): { value: string; label: string }[] {
    return this.unitsOfMeasure.map(u => ({ value: String(u.uomID), label: u.uomCode }));
  }

  @Output() closeCanvas = new EventEmitter<void>();
  @Output() save = new EventEmitter<any>();

  editData: any = {};

  ngOnChanges(changes: SimpleChanges): void {
    if (this.visible && this.item && (changes['visible'] || changes['item'])) {
      this.editData = { ...this.item };
    }
  }

  get title(): string {
    const isNew = this.item?.isNew;
    switch (this.mode) {
      case 'variable': return isNew ? 'Add Variable Overhead' : 'Edit Variable Overhead';
      case 'fixed':    return isNew ? 'Add Fixed Overhead'    : 'Edit Fixed Overhead';
      case 'salary':   return isNew ? 'Add Salary'           : 'Edit Salary';
      case 'employee': return isNew ? 'Add Employee'         : 'Edit Employee';
    }
  }

  onSave(): void {
    this.save.emit({ ...this.editData });
    this.closeCanvas.emit();
  }

  onClose(): void {
    this.closeCanvas.emit();
  }
}
